import axios from 'axios';

export const HTTP = axios.create({
  baseURL: "https://api.crowd-scout.com",
  // baseURL: "http://localhost:8000",
  withCredentials: true,
  xsrfHeaderName: "X-CSRFTOKEN",
  xsrfCookieName: "csrftoken",
})